import React, { useState } from 'react';
import './userProfileAttendanceDetailsV3.css';
import moment from 'moment';
import ShowMap from 'pages/attendanceNew/Modals/showMap';

const timerIcon = require("../../Assets/userManagementV3/timer.png").default;
const pLocation = require("../../Assets/userManagementV3/permenant location.png").default;
const tLocation = require("../../Assets/userManagementV3/temp location.png").default;

const UserGeoCardsV3 = ({ geoFence, locationDrawerVisible, setLocationDrawerVisible, getHolidays, params }) => {
    const [isShowMapModal, toggleShowMapModal] = useState(false);
    const [whichMapToShow, setMapToShow] = useState(null);
    const [particularGeoFenceOnMap, setGeoFenceOnMap] = useState(null);

    const handleShowMap = (locationItem) => {
        setGeoFenceOnMap(locationItem || geoFence?.currentLocation);
        setMapToShow('geoFenceMap');
        toggleShowMapModal(true);
    };

    const getLocations = () => {
        if (Array.isArray(geoFence?.geofences) && geoFence.geofences.length > 0) {
            return geoFence.geofences;
        }
        if (geoFence?.currentLocation && (geoFence.currentLocation.id || geoFence.currentLocation.title)) {
            return [geoFence.currentLocation];
        }
        return [];
    };

    const locations = getLocations();
    let tempIndex = 0;

    return (
        <div className='geofence-card-container'>
            {locations.map((item, index) => {
                const isTemporary = item?.type?.trim().toLowerCase() === 'temporary';
                if (isTemporary) {
                    tempIndex += 1;
                }
                const cardTitle = isTemporary ? `Temporary location ${tempIndex}` : 'Permanent location';
                const locationTitle = (item?.title && item.title.trim()) || '';
                const rawAddress = (item?.address && item.address.trim()) || '';
                const locationAddress = (rawAddress.toLowerCase() === locationTitle.toLowerCase()) ? '' : rawAddress;

                let timerText = 'All time';
                if (isTemporary) {
                    if (item.startDate && item.endDate) {
                        timerText = `${moment(item.startDate).format('DD/MM/YYYY')} to ${moment(item.endDate).format('DD/MM/YYYY')}`;
                    } else if (item.startDate) {
                        timerText = `From ${moment(item.startDate).format('DD/MM/YYYY')}`;
                    }
                }

                return (
                    <div key={item.id || item.geoFenceId || index} className='geofence-card'>
                        <div style={{ display: 'flex', padding: '16px 12px 16px 18px', justifyContent: 'space-between', alignItems: 'center' }}>
                            <div className="location-card" style={{ flex: 1, minWidth: 0, paddingRight: 8 }}>
                                <div className="location-title" title={cardTitle}>
                                    {cardTitle}
                                </div>
                                {locationTitle && (
                                    <div className="location-sub-title m-t-5" title={locationTitle}>
                                        {locationTitle}
                                    </div>
                                )}
                                {locationAddress && (
                                    <div className="location-address m-t-5" title={locationAddress}>
                                        {locationAddress}
                                    </div>
                                )}
                                <div className='m-t-5' style={{ display: 'flex', alignItems: 'center' }}>
                                    <img src={timerIcon} alt="timer" style={{ display: 'block' }} />
                                    <span className='timer-text'>{timerText}</span>
                                </div>
                            </div>
                            <div className="map-section" style={{ width: 'auto', flexShrink: 0 }}>
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                    <div className='location-container' style={{ paddingRight: 0, justifyContent: 'center' }}>
                                        <img
                                            style={{ height: 56, width: 56 }}
                                            src={isTemporary ? tLocation : pLocation}
                                            alt="location-icon"
                                        />
                                    </div>
                                    <div className="map-button" style={{ paddingTop: 12, paddingRight: 0, textAlign: 'center', cursor: 'pointer' }} onClick={() => handleShowMap(item)}>
                                        VIEW ON MAP
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            })}

            {isShowMapModal && (
                <ShowMap
                    open={isShowMapModal}
                    onCancel={() => {
                        toggleShowMapModal(false);
                        setMapToShow(null);
                        setGeoFenceOnMap(null);
                    }}
                    geoFenceLocationOnMap={particularGeoFenceOnMap}
                    whichMapToShow={whichMapToShow}
                />
            )}
        </div>
    );
};

export default UserGeoCardsV3;